import { FormControl, InputLabel } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import React from 'react'

export type NewOptionType = {
  label: string
  value?: string | number
  options?: NewOptionType[]
}

type Props = {
  options: Array<NewOptionType>
  label?: string
  placeholder?: string
  className?: string
  value?: string | number
  isClearable?: boolean
  onChange: (value: string | number) => void
  isSearchable?: boolean
  isCreatable?: boolean
  onCreateOption?: (...props: NewOptionType[]) => unknown
  formatCreateLabel?: (...props: NewOptionType[]) => unknown
  getOptionLabel?: (props: NewOptionType) => string
  getOptionValue?: (...props: NewOptionType[]) => unknown
  getValueOverride?: (...props: NewOptionType[]) => unknown
}

const defaultValue = {
  label: '',
  value: '',
}

export default function NewSelect({ onChange, options, label, value = '', getOptionLabel }: Props) {
  function handleChange(event: SelectChangeEvent) {
    onChange(event.target.value)
  }

  return (
    <FormControl variant='standard' sx={{ width: '100%' }}>
      <InputLabel>{label}</InputLabel>
      <Select value={String(value)} onChange={handleChange} label={label}>
        {[defaultValue, ...options].map((option) => {
          return (
            <MenuItem key={option.label} value={option.value}>
              {getOptionLabel ? getOptionLabel(option) : option.label}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}
